export default "<app-edit-kpi [headderText] = \"'Replicate Commission Plan'\"></app-edit-kpi>";